/**
 * Child Service Report Summary Page (read-only, printable)
 * Owner-only sidebar view of the child service report status for full-time children.
 * Mirrors the read-only summary that used to appear inside the compliance checklist.
 * Editing/creating individual reports still happens in Children Records.
 */
import AppShell from "@/components/layout/AppShell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";
import ChildServiceReportSummaryTab from "@/components/compliance/ChildServiceReportSummaryTab";

const ChildServiceReportSummaryPage = () => {
  return (
    <AppShell pageTitle="Child Service Report" breadcrumb>
      <div className="p-4 md:p-6 space-y-4" data-testid="child-service-report-summary-page">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-[#1a365d]">
              <FileText className="w-5 h-5" />
              Child Service Report — Summary
            </CardTitle>
            <p className="text-sm text-gray-500 mt-1">
              Read-only overview of every full-time child's service report status. Use the
              Print button for a hard copy. To fill out or update a child's report, open it
              from <span className="font-medium">Children → Compliance Records</span>.
            </p>
          </CardHeader>
          <CardContent>
            <ChildServiceReportSummaryTab />
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
};

export default ChildServiceReportSummaryPage;
